import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  courses: [],
  media: {
    // Legacy MyStep exposed these as jwplayer_status / jw_seek_disabled_status.
    // Unknown should not force JW over an available YouTube lesson video.
    jwplayerStatus: null,
    jwSeekDisabledStatus: false,
  },
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const slice = createSlice({
  name: 'coursesList',
  initialState,
  reducers: {
    coursesRequested(state) {
      state.status = 'loading';
      state.error = null;
    },
    coursesLoaded(state, action) {
      state.status = 'succeeded';
      state.courses = action.payload;
      state.error = null;
    },
    courseMediaSettingsLoaded(state, action) {
      const { jwplayerStatus, jwSeekDisabledStatus } = action.payload ?? {};
      if (!state.media) state.media = { ...initialState.media };
      if (typeof jwplayerStatus === 'boolean') {
        state.media.jwplayerStatus = jwplayerStatus;
      }
      if (typeof jwSeekDisabledStatus === 'boolean') {
        state.media.jwSeekDisabledStatus = jwSeekDisabledStatus;
      }
    },
    coursesFailed(state, action) {
      state.status = 'failed';
      state.error = action.payload ?? 'Failed to load courses';
    },
  },
});

export const {
  coursesRequested,
  coursesLoaded,
  courseMediaSettingsLoaded,
  coursesFailed,
} = slice.actions;
export const coursesListReducer = slice.reducer;
